package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.customer_card_tab.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card_detail.LoyaltyCardDetail
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.extractDate
import org.hs_soft.runmynesto.domain.util.extractTime
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.MediumContentTitle

@Composable
fun CustomerCardTabCard(
    windowSizeMode: WindowSizeModeEnum,
    selectedLoyaltyCard: LoyaltyCardDetail?,
    setIsActiveStatus:(Boolean)->Unit,
)
{
    Column(
        modifier = Modifier
            .margin(bottom = Dimen.extraLargePadding)
    )
    {
        MediumContentTitle(
            title = Strings.current().card,
        )

        if (windowSizeMode== WindowSizeModeEnum.Desktop)
        {
            Row(
                verticalAlignment = Alignment.CenterVertically
            ){
                content(
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    setIsActiveStatus={
                        setIsActiveStatus(it)
                    }
                )
            }
        }else{
            Column()
            {
                content(
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    setIsActiveStatus={
                        setIsActiveStatus(it)
                    }
                )
            }
        }




    }
}

@Composable
private fun content(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    setIsActiveStatus: (Boolean) -> Unit
) {
    Row()
    {
        CustomEditText(
            modifier = Modifier,
            isEnabled = false,
            label = Strings.current().cardNumber,
            value = selectedLoyaltyCard?.id ?: "",
            marginRight = Dimen.largePadding,
            marginBottom = Dimen.smallPadding,
            isDecimal = true,
            width = Dimen.highNormalEditTextWidth,
            isRequired = false,
            hint = "",
            onFocusIn = {

            },
            onFocusOut = {},
            onInputChange = {it, validation ->

            },
        )


        CustomEditText(
            modifier = Modifier,
            isEnabled = false,
            label = Strings.current().internetAccessCode,
            value = selectedLoyaltyCard?.accessCode ?: "",
            width = Dimen.highNormalEditTextWidth,
            marginRight = Dimen.largePadding,
            isRequired = false,
            hint = "",
            marginBottom = Dimen.smallPadding,
            onFocusIn = {

            },
            onFocusOut = {},
            onInputChange = {it, validation ->

            },
        )
    }

    Row()
    {
        CustomEditText(
            modifier = Modifier,
            isEnabled = false,
            label = Strings.current().lastUsed,
            marginRight = Dimen.largePadding,
            width = Dimen.highNormalEditTextWidth,
            value = extractDate(selectedLoyaltyCard?.lastUpdatedAt ?: "") ?: "",
            endIconPath = Res.PathIcon.calendar,
            isRequired = false,
            hint = "",
            marginBottom = Dimen.smallPadding,
            onFocusIn = { },
            onFocusOut = {},
            onInputChange = {it, validation ->

            },
        )


        CustomEditText(
            modifier = Modifier,
            label = Strings.current().time,
            isEnabled = false,
            marginRight = Dimen.largePadding,
            value = extractTime(selectedLoyaltyCard?.lastUpdatedAt ?: "") ?: "",
            width = Dimen.highNormalEditTextWidth,
            endIconPath = Res.PathIcon.calendar,
            isRequired = false,
            hint = "",
            marginBottom = Dimen.smallPadding,
            onFocusIn = {

            },
            onFocusOut = {},
            onInputChange = {it, validation ->

            },
        )
    }


    CheckboxComponent(
        modifier = Modifier,
        checkStatus = selectedLoyaltyCard?.isActive ?: false,
        title = Strings.current().activate,
        onChecked = {
            setIsActiveStatus(true)
        },
        onUnChecked = {
            setIsActiveStatus(false)
        },
    )
}


